import { connectRouter, routerMiddleware } from 'connected-react-router';
import { applyMiddleware, compose, createStore } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { createBrowserHistory } from 'history';
import reducers from './reducers';

export const history = createBrowserHistory();

export const store = createStore(
  connectRouter(history)(reducers),
  {},
  compose(
    applyMiddleware(thunkMiddleware),
    applyMiddleware(routerMiddleware(history)),
    (typeof window.__REDUX_DEVTOOLS_EXTENSION__ !== 'undefined') ? window.__REDUX_DEVTOOLS_EXTENSION__() : f => f,
  ),
);

history.listen(() => {
  window.scrollTo(0, 0);
});